import React from "react";
import { Card, Form, Button, Row, Col } from "react-bootstrap";

const VideosSection = ({ data, onUpdate }) => {
  const videoUrls = Array.isArray(data?.videoUrls) && data.videoUrls.length > 0 ? data.videoUrls : [""];

  const handleChange = (field, value) => {
    onUpdate({
      ...data,
      [field]: value,
    });
  };

  const updateVideoUrl = (index, value) => {
    const updatedVideoUrls = [...videoUrls];
    updatedVideoUrls[index] = value;
    handleChange("videoUrls", updatedVideoUrls);
  };

  const addVideoUrl = () => {
    handleChange("videoUrls", [...videoUrls, ""]);
  };

  const removeVideoUrl = (index) => {
    const updatedVideoUrls = videoUrls.filter((_, i) => i !== index);
    handleChange("videoUrls", updatedVideoUrls.length > 0 ? updatedVideoUrls : [""]);
  };

  return (
    <Card className="mb-4 shadow">
      <Card.Header className="bg-neutral-gray text-dark d-flex justify-content-between align-items-center">
        <h5 className="mb-0 text-dark">Videos Section</h5>
        <Form.Check
          type="checkbox"
          label="Visible"
          checked={data?.isVisible ?? true}
          onChange={(e) => handleChange("isVisible", e.target.checked)}
          className="mb-0"
        />
      </Card.Header>

      {data?.isVisible && (
        <Card.Body>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h6 className="mb-0">Video URLs</h6>
            <Button variant="outline-primary" size="sm" onClick={addVideoUrl}>
              + Add Video URL
            </Button>
          </div>

          {videoUrls.map((url, index) => (
            <div key={index} className="border rounded p-3 mb-3 bg-light-subtle">
              <Row className="align-items-center">
                <Col>
                  <Form.Group>
                    <Form.Label className={index === 0 ? "fw-semibold" : ""}>
                      {index === 0 ? "Primary Video URL" : `Video URL ${index + 1}`}
                    </Form.Label>
                    <Form.Control
                      type="url"
                      value={url}
                      onChange={(e) => updateVideoUrl(index, e.target.value)}
                      placeholder="Paste video URL here"
                    />
                  </Form.Group>
                </Col>
                <Col xs="auto" className="mt-3 mt-md-0">
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => removeVideoUrl(index)}
                  >
                    ×
                  </Button>
                </Col>
              </Row>
            </div>
          ))}
        </Card.Body>
      )}
    </Card>
  );
};

export default VideosSection;
